import { reactive, ref, computed } from '@vue/composition-api';

const focusedCardId = ref(null);
const showOutline = ref(false);
const showNoteCardPanel = ref(false);
const editingCardId = ref(null);
const editingNoteId = ref(null);
const zoomedCardId = ref(null);
const activeContextId = ref(null);

export default function useContext() {
  const setFocusedCardId = id => {
    console.log('set focused note doc', id);
    focusedCardId.value = id;
    console.log(focusedCardId);
  };

  const setShowOutline = val => {
    showOutline.value = val;
  };

  const setActiveContextId = val => {
    activeContextId.value = val;
  };

  const setShowNoteCardPanel = val => {
    if (val !== undefined) {
      showNoteCardPanel.value = val;
    } else {
      showNoteCardPanel.value = !showNoteCardPanel.value;
    }
  };

  const setEditingCardId = id => {
    // if (editingCardId.value !== id) {
    editingCardId.value = id;
    // }
  };

  const setZoomedCardId = id => {
    zoomedCardId.value = id;
  };

  const setEditingNoteId = id => {
    // if (editingNoteId.value !== id) {
    // editingNoteId.value = id;
    // }
  };

  return {
    focusedCardId,
    setFocusedCardId,
    showOutline,
    setShowOutline,
    editingCardId,
    setEditingCardId,
    editingNoteId,
    setEditingNoteId,
    zoomedCardId,
    setZoomedCardId,
    showNoteCardPanel,
    setShowNoteCardPanel,
    activeContextId,
    setActiveContextId
  };
}
